import { render, staticRenderFns } from "./RoomFile.vue?vue&type=template&id=4980548d"
import script from "./RoomFile.vue?vue&type=script&lang=js"
export * from "./RoomFile.vue?vue&type=script&lang=js"
import style0 from "./RoomFile.vue?vue&type=style&index=0&id=4980548d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports